import type { ReactNode } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useLenis } from "@/hooks/useLenis";

interface SiteLayoutProps {
  children: ReactNode;
  navbarVariant?: "overlay" | "solid";
}

export default function SiteLayout({ children, navbarVariant = "overlay" }: SiteLayoutProps) {
  useLenis();
  return (
    <div className="min-h-screen bg-cream text-ink flex flex-col">
      <Navbar variant={navbarVariant} />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}